export default __webpack_public_path__ + "static/media/drag-handle.eb1eae79.svg";